module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES96UC3']['10']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "details1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES96UC3']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codempid",
      "name": "coddesc_codempid"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codempid) + " - " + _vm._s(_vm.detail.tab1.desc_codempid))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES96UC3']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "dtereq",
      "name": "dtereq"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtereq)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES96UC3']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "dtechq",
      "name": "dtechq"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtechq)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES96UC3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codidchq",
      "name": "coddesc_codidchq"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codidchq) + " - " + _vm._s(_vm.detail.tab1.desc_codidchq))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES96UC3']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codchgsh",
      "name": "coddesc_codchgsh"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codchgsh) + " - " + _vm._s(_vm.detail.tab1.desc_codchgsh))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES96UC3']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100 txtarea-width response-full-width",
    attrs: {
      "id": "reason",
      "name": "reason"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.reason))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "detail-block-float detail-block-left"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES96UC3']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codempid2",
      "name": "coddesc_codempid2"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codempid2) + " - " + _vm._s(_vm.detail.tab1.desc_codempid2))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES96UC3']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_shfreqo",
      "name": "coddesc_shfreqo"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.shfreqo) + " - " + _vm._s(_vm.detail.tab1.desc_shfreqo))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES96UC3']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_shfreqn",
      "name": "coddesc_shfreqn"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.shfreqn) + " - " + _vm._s(_vm.detail.tab1.desc_shfreqn))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-block-float detail-block-right"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES96UC3']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codidchq2",
      "name": "coddesc_codidchq2"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codidchq2) + " - " + _vm._s(_vm.detail.tab1.desc_codidchq2))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES96UC3']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_shfreqo2",
      "name": "coddesc_shfreqo2"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.shfreqo2) + " - " + _vm._s(_vm.detail.tab1.desc_shfreqo2))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES96UC3']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_shfreqn2",
      "name": "coddesc_shfreqn2"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.shfreqn2) + " - " + _vm._s(_vm.detail.tab1.desc_shfreqn2))])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-124db777!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres96u/detail.vue
// module id = 3569
// module chunks = 1